/**
 * Copyright Motili Inc., 2023 All Rights Reserved
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useServiceWorker } from 'useServiceWorker';

export const history = {
    push: undefined,
    location: undefined,
};

const GlobalHistory = () => {
    const location = useLocation();
    history.push = useNavigate();
    const { setPathname } = useServiceWorker();

    useEffect(() => {
        history.location = location;
        setPathname(location.pathname);
    }, [location, setPathname]);

    return null;
};

export default GlobalHistory;
